module.exports = __webpack_public_path__ + "6c4a0dbc/img/lock-icon.bb9c7166.svg";